import React, { useEffect, useState } from "react";
import "./Card_Section.css";
import { useNavigate } from "react-router-dom";
import Common_Title from "../../common_component/common_title/Common_Title";
import Common_Btn_Yellow from "../../common_component/common_btn_yellow/Common_Btn_Yellow";
import { getData } from "../../../utils/api";

function Card_Section() {
  const navigate = useNavigate();

  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/cruise-package/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, []);

  return (
    <section className="argentina_section card_section">
      <div className="cruise_section">
        <div className="container">
          <div className="row">
            {packages.map((item, index) => (
              <div className="col-lg-6 col-md-6 mb-4" key={index}>
                <div className="cruise_card">
                  <div className="card_wrapper">
                    <div className="cruise_img">
                      <img
                        src={item?.images[0]?.image}
                        alt={item?.title}
                        className="image_destination"
                      />
                      <span className="night_badge">{item?.nights}</span>
                    </div>
                  </div>

                  <div className="cruise_content">
                    <h4 className="cruise_title">
                      {item?.title}
                      <span> ({item?.subtitle})</span>
                    </h4>

                    <p>
                      Departing:- <strong>{item?.departed}</strong>
                    </p>
                    <p>
                      Visiting:- <strong>{item?.visiting}</strong>
                    </p>
                    <p>
                      Ship:-{" "}
                      <strong>{item?.itineraries[0]?.transfer_type}</strong>
                    </p>

                    <div className="cruise_footer">
                      <div className="price">
                        {item?.discounted_price} <span> /Adult</span>
                      </div>
                    </div>

                    <small className="price_note">
                      *Price per person, based on 2 guests per cabin. Excludes
                      port charges & gratuities.
                    </small>

                    <div className="yellow_btn">
                      <Common_Btn_Yellow
                        text="Book Now"
                        className="book_btn"
                        onClick={() => navigate(`/cruise-details/${item.id}`)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Card_Section;
